import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IFestivals, IFestivalsInitialState } from "./festivalsModel";
import {
  ActiveInactiveFestivals,
  createFestivals,
  deleteFestivals,
  getAllActiveFestivals,
  getAllFestivals,
  getFestivalsByID,
  updateFestivals,
} from "./services/festivals.services";

const initialState: IFestivalsInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  FestivalsList: [],
  FestivalsID: null,
  FestivalsDetail: {
    Title: "",
    Description: "",
    IsActive: 1,
  },
};

const festivalSlice = createSlice({
  name: "festivals",
  initialState,
  reducers: {
    clearFestivalsDetails: (state) => {
      state.FestivalsDetail = initialState.FestivalsDetail;
    },
    setFestivalsID: (state, action) => {
      state.FestivalsID = action.payload;
    },
    clearFestivalsID: (state) => {
      state.FestivalsID = initialState.FestivalsID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllFestivals.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllFestivals.fulfilled,
      (state, action: PayloadAction<IFestivals[]>) => {
        state.loading = false;
        state.FestivalsList = action.payload || [];
      }
    );
    builder.addCase(getAllFestivals.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.FestivalsList = [];
    });
    builder.addCase(createFestivals.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createFestivals.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createFestivals.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateFestivals.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateFestivals.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateFestivals.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteFestivals.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteFestivals.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteFestivals.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getFestivalsByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getFestivalsByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.FestivalsDetail = action.payload;
    });
    builder.addCase(getFestivalsByID.rejected, (state, action) => {
      state.formLoading = false;
      state.FestivalsDetail = initialState.FestivalsDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveFestivals.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveFestivals.fulfilled,
      (state, action: PayloadAction<IFestivals[]>) => {
        state.loading = false;
        state.FestivalsList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveFestivals.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.FestivalsList = [];
    });
    builder.addCase(ActiveInactiveFestivals.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveFestivals.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveFestivals.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearFestivalsDetails, clearFestivalsID, setFestivalsID } =
  festivalSlice.actions;
export default festivalSlice.reducer;
